import { createFeatureSelector } from "@ngrx/store";
import { membersFeatureKey, MembersState } from "./members.reducer";

export const selectMembersState =
  createFeatureSelector<MembersState>(membersFeatureKey);
